import React, {PropTypes} from 'react';
const Loading = require('react-loading');
//import '../../../styles/common/Loading.css'

const loadingStyle = {
  width: "64px",
  marginLeft: "auto",
  marginRight: "auto"
};

const DynamicDropDownMenu = ({hideDropDown, onSelect, NAICSOptions, naicsLoading}) => {
  if (NAICSOptions.length === 0) {
    return null;
  }
  return (
    <div className="dynamic-dropdown-menu col-md-12" hidden={hideDropDown}>
      <div hidden={!naicsLoading} style={loadingStyle}>
        <Loading type="cylon" color="#e3e3e3"/>
      </div>
      {NAICSOptions.map(option => {
        return (
          <a
            tabIndex="0"
            className="dropdown-item"
            id={option.name}
            name={option.description__value}
            key={option.name}
            onClick={onSelect}
            href="#">
            {option.description__value + " " + option.name}
          </a>
        );
      })
}
    </div>
  );
};

DynamicDropDownMenu.propTypes = {
  hideDropDown: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
  NAICSOptions: PropTypes.array.isRequired,
  naicsLoading: PropTypes.bool.isRequired
};

export default DynamicDropDownMenu;



/** WEBPACK FOOTER **
 ** ./src/components/establishment/NAICS/DynamicDropDownMenu.js
 **/